import * as React from "react";
export default function Intro(){
  return (<div className="intro2">
  <div className="ihead">Hello, I'm Pranshu</div>
  <div className="ides">
    I am currently learning the code to bring some value to society.
    Interested in anything related to tech.
  </div>
</div>)
}